import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GetBackgroundImageStylePipe } from "./get-background-image-style.pipe";

@NgModule({
  declarations: [GetBackgroundImageStylePipe],
  imports: [CommonModule],
  exports: [GetBackgroundImageStylePipe],
})
export class GetBackgroundImageStylePipeModule {}
